import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { BusService } from '../services/bus.service';
import { EventsService } from '../services/events.service';

/**
 * Checks if a user is authenticated and with a valid token, otherwise redirects them to the login page.
 */
@Injectable()
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private bus: BusService,
    private events: EventsService,
  ) {
    /* const token = this.cookieService.get('token');
    if (token) {
      const decodedToken = decode(token);
      if (decodedToken.exp) {
        if (decodedToken.exp < new Date().getTime()) {
          console.warn('token expired on', new Date(decodedToken.exp));
          this.bus.publish(this.events.notified.user.logout);
        }
      } else {
        this.bus.publish(this.events.notified.user.logout);
      }
    } */
  }

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const token = this.cookieService.get('token');

    if (token) {
      return true;
    }

    // If not logged in, redirect to login
    this.router.navigate(['login'], {
      queryParams: Object.assign(
        { next: route.url.join('/') },
        route.queryParams,
      ),
    });

    return false;
  }
}
